import { atom } from 'recoil';

export const hauntingTargetAtom = atom<{
	targetId: string | null;
	targetType: 'instructor' | 'student' | null;
}>({
	key: 'hauntingTargetAtomKey',
	default: {
		targetId: null,
		targetType: null,
	},
});

export const hauntedConnectionsAtom = atom<string[]>({
	key: 'hauntedConnectionsAtomKey',
	default: [],
});
